import { useSetSearchParams } from '@hook/useSetSearchParams';
import { useEffect, useState } from 'react';
import { Trans } from 'react-i18next';

export interface IOnOffProp {
    watch: string;
    title: string;
    description: string;
    initVal: string;
    resetObj: Record<string, string>;
    ga360str: string;
    activeChecked: string | null;
    submitCallback?: (_d: string) => void;
}

export const OnOff = ({ props }: { props: IOnOffProp }) => {
    const { watch, title, description, initVal, submitCallback, resetObj, ga360str, activeChecked } = props;
    const [dat, datSet] = useState(initVal);
    const setParams = useSetSearchParams();

    useEffect(() => {
        if (!activeChecked) return;
        datSet(activeChecked);
    }, [activeChecked]);

    const [isButtonDisabled, setButtonDisabled] = useState<boolean>(false);

    const onChangeVal = (_bool: string) => {
        if (!isButtonDisabled) {
            setButtonDisabled(true);
            setTimeout(() => setButtonDisabled(false), 500);
            setParams({ [watch]: _bool, ...resetObj });
            submitCallback?.(_bool);
        }
    };

    return (
        <section className="sell">
            <header>{title}</header>
            <article>
                <p>
                    <Trans>{description}</Trans>
                </p>
                <div>
                    <input
                        onChange={() => {
                            onChangeVal('true');
                        }}
                        checked={dat === 'true'}
                        disabled={isButtonDisabled}
                        type="radio"
                        id="on"
                        name="onoff"
                        value="true"
                    />
                    <label htmlFor="on" data-areas={ga360str} data-contents="ON">
                        ON
                    </label>
                    <br />
                    <input
                        onChange={() => {
                            onChangeVal('false');
                        }}
                        checked={dat === 'false'}
                        disabled={isButtonDisabled}
                        type="radio"
                        id="off"
                        name="onoff"
                        value="false"
                    />
                    <label htmlFor="off" data-areas={ga360str} data-contents="OFF">
                        OFF
                    </label>
                    <br />
                </div>
            </article>
        </section>
    );
};
